import React from 'react'
import PageContainer from '../../layout/PageContainer';
import GarantiaPolicyList from './GarantiaPolicyList';


const GarantiaPolicyListContainer = () => (
  <PageContainer
    breadcrumbs={[
      { id: 0, name: 'SEGURO DE CRÉDITO', url: '/' },
      { id: 1, name: 'ASEGURADO', url: '/asegurado/polizas-garantia' },
      { id: 2, name: 'PÓLIZAS GARANTÍA'},
    ]}
    clientFilter={{
      type: 'asegurado',
      ramo: 'garantia',
      showFilter: true,
    }}
  >
    {(client) => (
      <GarantiaPolicyList client={client} />
    )}
  </PageContainer>
);

export default GarantiaPolicyListContainer;
